<template>
    <div class="skeleton">
        <base-skeleton class="head themed-skeleton"/>
        <div v-for="i in items" :key="i" class="item is-clearfix">
            <base-skeleton class="icon is-pulled-left themed-skeleton" width="17px"/>
            <base-skeleton class="is-pulled-left themed-skeleton" :width="rand_width()"/>
        </div>
    </div>
</template>

<script>
import randint from '../../utils/random';

export default {
    name: 'SidebarSkeleton',
    props: { items: { type: Number, default: 4 } },
    data() {
        return { background: '#4d4dd4', blink: '#726ce7' };
    },
    methods: {
        rand_width() {
            return `${randint(80, 160)}px`;
        },
    },
};
</script>

<style scoped>
    .item {margin-top: 24px;}
    .head {width: 90px; height: 15px;}
    .skeleton {display: block; margin-top: 60px;}
    .icon {margin-right: 10px;}
</style>
